import { ordenTrabajoInsumoApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'ORDEN_TRABAJO_INSUMO',
    api: ordenTrabajoInsumoApi,
    relUrl: id,
  });

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'ORDEN_TRABAJO_INSUMO',
    api: ordenTrabajoInsumoApi,
    relUrl: `indexByParent/${id}`,
  });

export const getAll = getListDataAction({
  dataName: 'ORDEN_TRABAJO_INSUMO',
  api: ordenTrabajoInsumoApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'ORDEN_TRABAJO_INSUMO',
    api: ordenTrabajoInsumoApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'ORDEN_TRABAJO_INSUMO',
    api: ordenTrabajoInsumoApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'ORDEN_TRABAJO_INSUMO',
  api: ordenTrabajoInsumoApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'ORDEN_TRABAJO_INSUMO',
    api: ordenTrabajoInsumoApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('ORDEN_TRABAJO_INSUMO');
export const setDeletedPending = createListDataDeletedPending(
  'ORDEN_TRABAJO_INSUMO'
);
